
/** @format */

import React, { useState, useEffect } from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { useStyles } from '../style';
import { SimpleDialog, ButtonLoading } from 'components';
import Services from '../../../services/Services';
import TextItemDotted from '../../../components/TextItemDotted';
import { useNavigate } from 'react-router-dom';
import createToast from 'components/Toast/Toast';

const IssuingWarranty = (props) => {
  const classes = useStyles();
  const { result } = props;
  const navigate = useNavigate();
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isloadProgress, setIsLoadProgress] = useState(false);
  useEffect(() => {
    if (result?.source?.isClosed === false &&
      result?.source?.error?.hasError === true &&
      result?.source?.warrantyStatus === 'ERROR' &&
      (result?.source?.warrantyStep === 'REGISTERED' || result?.source?.warrantyStep === 'PENDING_TO_REGISTER')
    ) {
      setIsOpenExportDG(true)
    }
  }, [result])

  const retryRequest = async () => {
    setIsLoadProgress(true)
    const param = {
      'entity-id': result?.source?.entityId,
      'warrantySubStep': result?.source?.warrantySubStep,
    };
    Services.postWarrantiesRetry(result?.source?.entityId, param)
      .then((res) => {
        setIsLoadProgress(false);
        createToast('موفق', 'درخواست مجدد با موفقیت انجام شد', 'success');
        navigate('/Warranty/RequestList')
      })
      .catch((error) => {
        setIsLoadProgress(false);

      });
  };
  return (
    <>
      {result ? (
        <Grid container direction="row" alignItems="center" spacing={0} item xs={12}>
          <Grid className={classes.information}>

            {/* وضعیت  ایجاد  شده */}
            {(result?.source?.warrantyStep !== 'REGISTERED' ||
              result?.source?.warrantyStep !== 'PENDING_TO_REGISTER')
              && result?.source?.warrantyStatus === 'CREATED' ? (
              <Grid className={classes.blockCard}>
                <Grid className={classes.blockCardHeader}>
                  <h3 className={classes.blockCardTitle}>جزئیات و وضعیت  صدور ضمانت‌نامه </h3>
                </Grid>

                {
                  <>
                    <TextItemDotted
                      title="شماره پرونده "
                      title2={result?.source?.warrantyFileNumber}
                    />

                  </>
                }
                <Grid className={classes.blockCardFooter}>
                  <h3 className={classes.blockCardFooterTitle}>  صدور ضمانت‌نامه با موفقیت انجام شد.</h3>
                </Grid>
              </Grid>
            ) : (
              ''
            )}

            {/* وضعیت  انتظار   */}
            {(result?.source?.warrantyStep === 'REGISTERED' ||
              result?.source?.warrantyStep === 'PENDING_TO_REGISTER') &&
              result?.source?.warrantyStatus === 'WAITING' ? (
              <Grid className={classes.blockCard}>
                <Grid className={classes.blockCardHeader}>
                  <h3 className={classes.blockCardTitle}>جزئیات و وضعیت  صدور ضمانت‌نامه </h3>
                </Grid>
                {
                  <>

                    <TextItemDotted
                      title="شماره پرونده "
                      title2={result?.source?.warrantyFileNumber}
                    />

                  </>
                }

                <Grid className={classes.blockCardFooter}>
                  <h3 className={classes.blockCardFooterTitle}>
                    درخواست  صدور ضمانت‌نامه در انتظار بررسی می باشد.
                  </h3>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            {/* وضعیت  رد شده یا بسته شده   */}
            {result?.source?.warrantyStep === 'UNREGISTERED' &&
              result?.source?.warrantyStatus === 'REJECTED' &&
              result?.source?.isClosed === true &&
              result?.source?.error?.hasError === true
              ? (
                <Grid className={classes.blockCard}>
                  <Grid className={classes.blockCardHeader}>
                    <h3 className={classes.blockCardTitle}>جزئیات و وضعیت  صدور ضمانت‌نامه </h3>
                  </Grid>
                  {
                    <>

                      <TextItemDotted
                        title="شماره پرونده "
                        title2={result?.source?.warrantyFileNumber}
                      />

                    </>
                  }

                  <Grid className={classes.blockCardFooter}>
                    <h3 className={classes.blockCardFooterTitle}>
                      پرونده حذف و درخواست بسته شده است.
                    </h3>
                  </Grid>
                </Grid>
              ) : (
                ''
              )}

            {/* وضعیت  خطا   */}
            {
              result?.source?.error?.hasError === true &&
                result?.source?.warrantyStatus === 'ERROR' &&
                (result?.source?.warrantyStep === 'REGISTERED' ||
                  result?.source?.warrantyStep === 'PENDING_TO_REGISTER')
                ? (
                  <Grid className={classes.blockCard}>
                    <Grid className={classes.blockCardHeader}>
                      <h3 className={classes.blockCardTitle}>جزئیات و وضعیت  صدور ضمانت‌نامه </h3>
                    </Grid>
                    {
                      <>

                        <TextItemDotted
                          title="شماره پرونده "
                          title2={result?.source?.warrantyFileNumber}
                        />

                      </>
                    }

                    <Grid className={classes.blockCardFooter}>
                      <h3 className={classes.blockCardFooterTitle}>
                        درخواست با خطا مواجه شده است.
                      </h3>
                    </Grid>
                  </Grid>
                ) : (
                  ''
                )}


          </Grid>
          <SimpleDialog
            onClose={() => setIsOpenExportDG(false)}
            fullWidth maxWidth="sm" open={isOpenExportDG} title="خطا در صدور ضمانت‌نامه">
            <Grid container style={{ textAlign: 'justify' }}>
              <p style={{ margin: '20px 0' }}>
                {result?.source?.error?.message}
              </p>
            </Grid>
            <Grid  style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}>

              <ButtonLoading
                type="submit"
                variant="contained"
                color="primary"
                loading={isloadProgress}
                name=" درخواست مجدد"
                onClick={() => retryRequest()}
              />
            </Grid>
          </SimpleDialog>
        </Grid>

      ) : (
        result?.length !== 0 ? (
          <div className={classes.loadingFinger}>
            <CircularProgress color="inherit" size={30} />
          </div>
        ) : (
          ''
        )
      )}
    </>
  );
};

export default IssuingWarranty;


